import { createContext, useContext } from "react";
import { UserPermissions } from "Shared/Types/fleetmanagementapi";
import { MODULES, PERMISSIONS } from "Shared/Types/permissions";
import { CommandPermissions } from "./commandPermissions";

/** Only populated after the current authenticated session has fetched its grants. */
export const CommandPermissionsContext =
  createContext<CommandPermissions | null>(null);
export const useVerifiedCommandPermissions = () =>
  useContext(CommandPermissionsContext);

export function parseCommandPermissions(
  data: UserPermissions,
): CommandPermissions {
  if (
    !data ||
    typeof data.has_full_access !== "boolean" ||
    !Array.isArray(data.modules)
  ) {
    throw new Error("Permission information is unavailable.");
  }
  const modules = new Set<MODULES>();
  const available_permissions = new Set<PERMISSIONS>();
  data.modules.forEach((module) => {
    modules.add(module.code_name as MODULES);
    module.permissions?.forEach((permission) => {
      available_permissions.add(permission.codename as PERMISSIONS);
      permission.sub_permissions?.forEach((child) =>
        available_permissions.add(child.codename as PERMISSIONS),
      );
    });
  });
  return {
    has_full_access: data.has_full_access,
    modules,
    available_permissions,
  };
}
export function commandPermissionFingerprint(
  permissions?: CommandPermissions | null,
) {
  return JSON.stringify([
    !!permissions?.has_full_access,
    [...(permissions?.modules || [])].sort(),
    [...(permissions?.available_permissions || [])].sort(),
  ]);
}
